import type { WidgetComponent } from './types';

// Every widget, keyed by its catalogue id — the module's file name. The
// catalogue itself (names and what each takes) is the backend's
// (backend/src/layout/widgets.py); a widget is added there and here as
// widgets/<id>.tsx, whose default export renders it. Each fetches its own data.
const modules = import.meta.glob<{ default: WidgetComponent }>('./*.tsx', { eager: true });

export const WIDGETS: Record<string, WidgetComponent> = Object.fromEntries(
  Object.entries(modules)
    .filter(([path]) => !path.endsWith('.test.tsx'))
    .map(([path, mod]) => [path.replace(/^\.\//, '').replace(/\.tsx$/, ''), mod.default]),
);
